module.exports = __webpack_public_path__ + "static/media/SyriaBanner.7db0205e.png";